import gtmEventTracker from '../gtm_event_tracker';
import {setClickEventTracker} from '../event_tracker/set_click_event_tracker';
import {setScrollEventTracker} from '../event_tracker/set_scroll_event_tracker';
import {setSubmitEventTracker} from '../event_tracker/set_submit_event_tracker';
import {setGTMClickEventTracker} from '../event_tracker/set_gtm_click_event_tracker';

export const eventTrackers = () => {
  setClickEventTracker();
  setScrollEventTracker();
  setSubmitEventTracker();

  gtmEventTracker.initialize();
  setGTMClickEventTracker();
};
